import { forwardRef, useEffect } from "react";
import { Image as ReactNativeImage } from "react-native-web";
import { isWebTouchable, styled, usePropsAndStyle } from "@tamagui/core";
import { ComponentWithViewTracking } from "../../helpers/analytics";
import { getBorderRadiusByVariant } from "./helpers";
import { jsx } from "react/jsx-runtime";
const BaseImageReactNative = styled(ReactNativeImage, {
  name: "Image",
  variants: {
    variant: (variant, extras) => {
      const orientation = extras.props.orientation || "";
      return getBorderRadiusByVariant(variant, orientation);
    }
  }
}), Image = forwardRef(function({
  analyticsName,
  trackImpression = !1,
  inViewThreshold,
  source,
  enableZoom = !1,
  ...inProps
}, ref) {
  inProps.variant === "circle" && (inProps.height = inProps.width);
  const [props, style] = usePropsAndStyle(inProps);
  useEffect(() => {
    const imageRef = isWebTouchable && ref && "current" in ref ? ref.current : void 0;
    if (isWebTouchable && imageRef && enableZoom) {
      let imageElementScale = 1;
      const SCALE_MAX = 4, start = { x: 0, y: 0, distance: 0 }, distance = (event) => Math.hypot(
        event.touches[0].pageX - event.touches[1].pageX,
        event.touches[0].pageY - event.touches[1].pageY
      ), handleTouchStart = (event) => {
        event.touches.length === 2 && (event.preventDefault(), start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2, start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2, start.distance = distance(event));
      }, handleTouchMove = (event) => {
        if (event.touches.length === 2) {
          event.preventDefault();
          let scale;
          event?.scale ? scale = event.scale : scale = distance(event) / start.distance, imageElementScale = Math.min(Math.max(1, scale), SCALE_MAX);
          const deltaX = ((event.touches[0].pageX + event.touches[1].pageX) / 2 - start.x) * 2, deltaY = ((event.touches[0].pageY + event.touches[1].pageY) / 2 - start.y) * 2, transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
          imageRef.style.transform = transform, imageRef.style.webkitTransform = transform, imageRef.style.zIndex = "9999", imageRef.style.transition = "ease 150ms";
        }
      }, handleTouchEnd = () => {
        imageRef.style.transform = "", imageRef.style.webkitTransform = "", imageRef.style.zIndex = "";
      };
      return imageRef?.addEventListener("touchstart", handleTouchStart), imageRef?.addEventListener("touchmove", handleTouchMove), imageRef?.addEventListener("touchend", handleTouchEnd), () => {
        imageRef?.removeEventListener("touchstart", handleTouchStart), imageRef?.removeEventListener("touchmove", handleTouchMove), imageRef?.removeEventListener("touchend", handleTouchEnd);
      };
    }
  }, [ref, enableZoom]);
  const BaseImageWithProps = /* @__PURE__ */ jsx(
    BaseImageReactNative,
    {
      ...props,
      accessibilityLabel: props.alt,
      source,
      style,
      ref
    }
  );
  return analyticsName && trackImpression ? /* @__PURE__ */ jsx(
    ComponentWithViewTracking,
    {
      Component: BaseImageWithProps,
      analyticsName,
      eventName: "imageViewEvent",
      inViewThreshold,
      ref,
      ...props
    }
  ) : BaseImageWithProps;
});
export {
  Image
};
